/**
 * 学术侧导出成功通知 — 触发 ScholarExportSuccessModal
 *
 * 与 utils/notifyExportSuccess（质量侧）独立频控，互不抢占。
 * sessionStorage：同会话只弹一次。
 */
const STORAGE_KEY = 'scholar_modal_shown'
const EVENT_NAME = 'show-scholar-export-modal'

export function notifyScholarExportSuccess(): void {
  if (typeof window === 'undefined') return
  try {
    if (sessionStorage.getItem(STORAGE_KEY)) return
  } catch {
    // sessionStorage 不可用 — 仍允许触发
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, '1')
  } catch {
    // 忽略写入失败
  }
  window.dispatchEvent(new CustomEvent(EVENT_NAME))
}
